import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { LivestreamSession } from './LivestreamSession';
import { EVENTS_I_HOST } from './SecurityRules';

export const StreamPlatformOptions = [
  { id: 'YOUTUBE', label: 'YouTube Live' },
  { id: 'TWITCH', label: 'Twitch' },
  { id: 'FACEBOOK', label: 'Facebook Live' },
  { id: 'LINKEDIN', label: 'LinkedIn Live' },
  { id: 'CUSTOM_RTMP', label: 'Custom RTMP Server' },
];

export const StreamDestinationStatusOptions = [
  { id: 'INACTIVE', label: 'Inactive' },
  { id: 'ACTIVE', label: 'Active - Streaming' },
];

export interface LivestreamSessionStreamDestinationRow {
  id: string;
  livestream_session_id: string;
  platform: string;
  stream_key: string;
  url: string;
  egress_id: string | null;
  status: string;
  created_at: string;
  updated_at: string;
}

export const LivestreamSessionStreamDestination: Entity<LivestreamSessionStreamDestinationRow> = {
  id: 'LivestreamSessionStreamDestination',
  title: 'Livestream Stream Destination',
  service: 'main',
  rowLabel: (row: LivestreamSessionStreamDestinationRow) => `${row.platform} - ${row.url}`,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.livestream_session_stream_destination',
  },
  security: [
    {
      role: 'user',
      action: 'read',
      access: 'conditional',
      condition: `livestream_session_id IN (SELECT id FROM livestream_session WHERE event_id IN ${EVENTS_I_HOST})`,
    },
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: `livestream_session_id IN (SELECT id FROM livestream_session WHERE event_id IN ${EVENTS_I_HOST} OR institution_id = {adminInstitutionId})`,
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['created_at', 'DESC']],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Text,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      listColumn: true,
    },
    livestream_session_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Livestream Session',
      refEntity: LivestreamSession,
      mandatory: true,
      listColumn: true,
    },
    platform: {
      seq: 15,
      type: FieldType.Options,
      label: 'Platform',
      options: StreamPlatformOptions,
      mandatory: true,
      listColumn: true,
    },
    stream_key: {
      seq: 20,
      type: FieldType.Text,
      label: 'Stream Key',
      mandatory: true,
      visible: false, // Hide in lists/logs
    },
    url: {
      seq: 25,
      type: FieldType.Text,
      label: 'Stream URL',
      mandatory: true,
      listColumn: true,
    },
    egress_id: {
      seq: 35,
      type: FieldType.Text,
      label: 'LiveKit Egress ID',
    },
    status: {
      seq: 40,
      type: FieldType.Options,
      label: 'Status',
      options: StreamDestinationStatusOptions,
      mandatory: true,
      listColumn: true,
    },
    created_at: {
      seq: 50,
      label: 'Created At',
      type: FieldType.Datetime,
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
    updated_at: {
      seq: 55,
      label: 'Updated At',
      type: FieldType.Datetime,
      persistence: PersistenceType.BackEndManaged,
    },
  },
};
